/* eslint-disable react/display-name */
import React from 'react';
import { Grid, Typography, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const TranslateSteps = (message) => {
  const { t } = useTranslation();
  return t(message);
};

const tourBodyBox = (selectorItem, i18nItem, tourName) => {
  return {
    selector: selectorItem,
    content: (stepHelper) => (
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography>
            {TranslateSteps(i18nItem)}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Button
            variant='contained'
            color='primary'
            onClick={() => {
              stepHelper.setIsOpen(false);
              localStorage.setItem(tourName, false);
            }}
          >
            {TranslateSteps('tour:avoidTutorial')}
          </Button>
        </Grid>
      </Grid>
    )
  };
};

export const tourStepsDashboard = (config) => {
  const { visibleTabs } = config;
  const dashboardSteps = [];
  for (let i = 0; i < visibleTabs.length; i++) {
    const item = tourBodyBox(`.dashboard-${visibleTabs[i].name}`,
      `tour:dashboard:${visibleTabs[i].name}`,
      'tour-dashboard');
    if (visibleTabs[i].name === 'pending') {
      dashboardSteps.unshift(item);
    } else {
      dashboardSteps.push(item);
    }
  }
  const langStep = tourBodyBox('.lang-changeLang',
    'tour:changeLang',
    'tour-dashboard');
  dashboardSteps.push(langStep);

  return dashboardSteps;
};

export const tourSteps = {
  createNewBundle: [
    tourBodyBox('.bundle-newBundle',
      'tour:bundle:newBundle',
      'tour-bundle'),
    tourBodyBox('.bundle-newBundle',
      'tour:bundle:newBundle2',
      'tour-bundle')
  ],
  createNewNotifCertificate: [
    tourBodyBox('.files-newNotification',
      'tour:notification:newNotif1',
      'tour-notification')
  ],
  createNewDocument: [
    tourBodyBox('.pending-newDocument',
      'tour:document:newDocument',
      'tour-document'),
    tourBodyBox('.pending-newDocument2',
      'tour:document:newDocument2',
      'tour-document'),
    tourBodyBox('.pending-newDocument2',
      'tour:document:stamper',
      'tour-document')
  ],
  createNewHash: [
    tourBodyBox('.files-newHash',
      'tour:file:newHash',
      'tour-file'),
    tourBodyBox('.files-newHash',
      'tour:file:newHash2',
      'tour-file')
  ],
  createNewIdentity: [
    tourBodyBox('.identity-newIdentity',
      'tour:identity:newIdentity',
      'tour-identity'),
    tourBodyBox('.identity-newIdentity',
      'tour:identity:newIdentity2',
      'tour-identity')
  ],
  createNewTemplate: [
    tourBodyBox('.template-newTemplate',
      'tour:template:newTemplate',
      'tour-template'),
    tourBodyBox('.template-newTemplate',
      'tour:template:newTemplate2',
      'tour-template'),
    tourBodyBox('.template-newTemplate',
      'tour:template:newTemplate3',
      'tour-template')
  ],
  document: [
    tourBodyBox('.document-downloadDocument',
      'tour:document:downloadDocument',
      'tour-document'),
    tourBodyBox('.document-uploadNewVersion',
      'tour:document:uploadNewVersion',
      'tour-document'),
    tourBodyBox('.document-expandDocument',
      'tour:document:expandDocument',
      'tour-document'),
    tourBodyBox('.document-lastStep',
      'tour:document:stamper',
      'tour-document')
  ],
  finished: [
    tourBodyBox('.finished-intro',
      'tour:finished:intro',
      'tour-finished')
  ]
};
